import axios from "axios";
import { toast } from "react-toastify";

export async function checkTokenValidation() {
    const token = localStorage.getItem("bearerToken")
    return axios.get(`${process.env.REACT_APP_API_URL}/protectedRoute`,
        {
            headers: { 'Authorization': `Bearer ${token}` }
        }).then((response) => {
            console.log(response.data)
            return response.data.success;
        }).catch((error) => {
            console.log(error)
            return false;
        })
}
export async function handleHangupCalls() {
    try {
        const token = localStorage.getItem("bearerToken")
        console.log(token)
        axios.get(`${process.env.REACT_APP_API_URL}/twilioHangupAllCalls`,
            { headers: { 'Authorization': `Bearer ${token}` } })
            .then((response) => {
                console.log(response)
                toast.success("All Calls Terminated Successfully", { toastId: "hangupAllCalls" });
                return true;
            })
            .catch(err => {
                console.log(err)
                toast.error("Error while hanging up calls", { toastId: "hangupAllCallsError" })
                return false;

            })
    } catch (err) {
        console.log(err)
        toast.error("Error while hanging up calls", { toastId: "hangupAllCallsError" })
        return false;
    }
}